import React from "react"
import PropTypes from "prop-types"
import FontAwesome from "react-fontawesome"
import Select from "react-select"

import { getSelectDropdownOptions } from "../../helpers/sharedHelperFunctions"

import "./OwnedBySearchInput.scss"

const populateFieldWithDepartmentName = props => {
  const preSelectedDepartment =
    props.departmentId &&
    props.departments.length > 0 &&
    props.departments.find(d => d.id === props.departmentId)
  return preSelectedDepartment
    ? { label: preSelectedDepartment.name, value: preSelectedDepartment.id }
    : undefined
}

const clearRenderer = () => {
  return <FontAwesome className="clearInput" name={"times"} />
}
class OwnedBySearchInput extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      suggestions: this.props.departments.map(dept => ({
        value: dept.id,
        label: dept.name,
      })),
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      suggestions: nextProps.departments
        .map(dept => ({
          value: dept.id,
          label: dept.name,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : -1)),
    }
  }
  onInputChange = inputChange => {
    this.setState({
      suggestions: getSelectDropdownOptions(
        inputChange,
        this.props.departments
      ),
    })
  }

  onChange = onChange => {
    this.setState({
      value: onChange,
    })
    this.props.updateOwnedBy(onChange ? onChange.value : "")
  }

  render() {
    const currentSearchSelection = populateFieldWithDepartmentName(this.props)
    return (
      <div className="OwnedBySearchInput">
        <label for="DeptDropdown" className="label no-margin-bottom min-width">
          Owned by
        </label>
        <Select
          id="DeptDropdown"
          name="DeptDropdown"
          className="dept-dropdown"
          isSearchable={true}
          isClearable={true}
          defaultValue={currentSearchSelection}
          value={currentSearchSelection}
          onChange={this.onChange}
          onInputChange={this.onInputChange}
          filterOption={() => true}
          options={this.state.suggestions}
          placeholder={"Anyone"}
          clearRenderer={clearRenderer}
        />
      </div>
    )
  }
}

OwnedBySearchInput.propTypes = {
  departmentId: PropTypes.string,
  departments: PropTypes.array,
  updateOwnedBy: PropTypes.func,
}

OwnedBySearchInput.defaultProps = {
  departmentId: "",
  departments: [],
}

export default OwnedBySearchInput
